import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

function OnetapScreen() {
  const [data, setData] = useState([]);
  const [tab, setTab] = useState("upcoming");

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const snap = await getDocs(
      collection(db, "onetap_tournaments")
    );

    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }));

    setData(list);
  };

  // 🔥 DELETE (with participants)

  const now = new Date();

  const filtered = data.filter((t) => {
    const time = t.time?.seconds
      ? new Date(t.time.seconds * 1000)
      : new Date();

    return tab === "upcoming" ? time >= now : time < now;
  });

  return (
    <div style={container}>
      <h1>🎮 OneTap CS Tournaments</h1>

      {/* CREATE */}
      <button style={createBtn} onClick={() => navigate("/create-onetap")}>
        ➕ Create Tournament
      </button>

      {/* TABS */}
      <div style={tabs}>
        <button
          style={tabBtn(tab === "upcoming")}
          onClick={() => setTab("upcoming")}
        >
          Upcoming
        </button>

        <button
          style={tabBtn(tab === "completed")}
          onClick={() => setTab("completed")}
        >
          Completed
        </button>
      </div>

      {/* LIST */}
      {filtered.map((t) => (
        <div key={t.id} style={card}>
          <h3>{t.title}</h3>

          <p>📍 {t.map}</p>
          <p>💰 Prize: ₹{t.prizePool}</p>
          <p>⚔ Per Kill: ₹{t.perKill || 0}</p>

          <p>
            ⏰{" "}
            {t.time?.seconds
              ? new Date(t.time.seconds * 1000).toLocaleString()
              : "No Time"}
          </p>

          {/* ACTIONS */}
          <div style={actions}>
            <button
    onClick={() =>
      navigate("/edit", {
        state: {
          id: t.id,
          data: t,
          collectionName: "onetap_tournaments",
        },
      })
    }
  >
    ✏️ Edit
  </button>
           <button
  style={smallBtn}
  onClick={() =>
    navigate("/delete", {
      state: {
        id: t.id,
        data: t,
        collectionName: "cs_tournaments",
      },
    })
  }
>
  ❌ Delete
</button>

           <button
  onClick={() =>
    navigate("/add-room", {
      state: {
        tournamentId: t.id,
        collectionType: "onetap_tournaments", // 🔥 change according to screen
      },
    })
  }
>
  🏠 Room
</button>

           <button
  disabled={t.winnerDeclared}
  onClick={async () => {
    // 🔥 participants fetch
    const snap = await getDocs(
      collection(db, "onetap_tournaments", t.id, "participants") // 👈 change per screen
    );

    const participantsData = snap.docs.map((d) => d.data());

    navigate("/decide-winner", {
      state: {
        tournamentId: t.id,
        participants: participantsData,
        tournamentData: t,
        collectionType: "onetap_tournaments", // 👈 IMPORTANT change per type
      },
    });
  }}
  style={{
    padding: "6px 10px",
    borderRadius: 6,
    border: "none",
    cursor: t.winnerDeclared ? "not-allowed" : "pointer",
    background: t.winnerDeclared ? "#16A34A" : "#2563EB",
    color: "#fff",
  }}
>
  {t.winnerDeclared ? "✅ Winner Done" : "🏆 Decide"}
</button>
          </div>
        </div>
      ))}
    </div>
  );
}

/* STYLES */

const container = {
  color: "white",
  padding: 20,
};

const createBtn = {
  background: "green",
  color: "#fff",
  padding: 10,
  border: "none",
  borderRadius: 8,
  marginBottom: 20,
  cursor: "pointer",
};

const tabs = {
  display: "flex",
  gap: 10,
  marginBottom: 20,
};

const tabBtn = (active) => ({
  padding: "8px 14px",
  borderRadius: 20,
  border: "none",
  cursor: "pointer",
  background: active ? "#2563EB" : "#1E2235",
  color: "#fff",
});

const card = {
  background: "#1E2235",
  padding: 15,
  borderRadius: 10,
  marginBottom: 12,
};

const actions = {
  marginTop: 10,
  display: "flex",
  gap: 10,
};
const smallBtn = {
  padding: "6px 10px",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default OnetapScreen;